export default "__VITE_ASSET__WIKTcfJR__"